import { Canvas } from '@react-three/fiber';
import React from 'react';
import { Scene, SceneProps } from './Scene';

export type ViewerProps = SceneProps;

export const Viewer: React.FC<ViewerProps> = ({ ...restProps }) => {
  return (
    // <View index={1} style={{ position: 'absolute', inset: 0, zIndex: -1 }}>
    <Canvas style={{ position: 'absolute', inset: 0, zIndex: -1 }}>
      <Scene {...restProps} />
    </Canvas>
  );
};
